import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { LORAX_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import { getAppMarketplaceUrl, getAssetMarketplaceUrl, getSolutionsDirectoryUrl } from '../utils/urls';
import HomeSection from './HomeSection';
import HomeSectionInner from './HomeSectionInner';
export const CARD_BUTTON_HEIGHT = 200; // TODO refactor to core

const CardWrapper = styled(UICardWrapper).withConfig({
  displayName: "MarketplaceCardsSection__CardWrapper",
  componentId: "wpez7i-0"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, LORAX_MEDIUM);

function CardButton({
  href,
  illustrationName,
  onClick,
  textLabel
}) {
  return /*#__PURE__*/_jsx(UILink, {
    className: "display-flex align-stretch",
    href: href,
    onClick: onClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      className: "text-center m-bottom-0",
      compact: true,
      height: CARD_BUTTON_HEIGHT,
      children: [/*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsx(UIIllustration, {
          height: 92,
          name: illustrationName
        })
      }), /*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsx("span", {
          className: "is--heading-5",
          children: textLabel
        })
      })]
    })
  });
}

const StyledHomeSection = styled(HomeSection).withConfig({
  displayName: "MarketplaceCardsSection__StyledHomeSection",
  componentId: "wpez7i-1"
})(["margin-top:-", "px;margin-bottom:-", "px;"], CARD_BUTTON_HEIGHT / 2, CARD_BUTTON_HEIGHT / 2);
export default function MarketplaceCardsSection({
  onTrackInteraction
}) {
  const {
    columns,
    className: responsiveClassName
  } = useResponsiveProps({
    className: {
      xs: 'p-bottom-0 p-top-14',
      md: 'p-y-0'
    },
    columns: {
      sm: 1,
      md: 3
    }
  });
  return /*#__PURE__*/_jsx(StyledHomeSection, {
    className: responsiveClassName,
    color: "transparent",
    "data-test-id": "marketplace-cards-section",
    children: /*#__PURE__*/_jsx(HomeSectionInner, {
      maxWidth: 716,
      children: /*#__PURE__*/_jsxs(UICardGrid, {
        columns: columns,
        children: [/*#__PURE__*/_jsx(CardButton, {
          href: getAssetMarketplaceUrl(),
          illustrationName: "marketplace-theme",
          onClick: () => onTrackInteraction('click asset marketplace card button'),
          textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.marketplaceButtons.assetMarketplaceTextLabel"
          })
        }), /*#__PURE__*/_jsx(CardButton, {
          href: getAppMarketplaceUrl(),
          illustrationName: "integrations",
          onClick: () => onTrackInteraction('click app marketplace card button'),
          textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.marketplaceButtons.appMarketplaceTextLabel"
          })
        }), /*#__PURE__*/_jsx(CardButton, {
          href: getSolutionsDirectoryUrl(),
          illustrationName: "marketplace-solutions-directory",
          onClick: () => onTrackInteraction('click solutions directory card button'),
          textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.marketplaceButtons.solutionsDirectoryTextLabel"
          })
        })]
      })
    })
  });
}